<template lang="jade">
  .c-card.c-card--event
    .c-card__image
      template(v-if="fdata.image.src")
        div.c-card__backdrop(":style"="fdata.image | backdrop")
    .c-card__content
      h3.c-card__title {{ fdata.title.value }}
      .c-card__date {{ fdata.date.value | format }}
      .c-card__text {{ fdata.desc.value }}
      .c-card__actions
        component("is"="type_buttonGroup" 
                  ":fdata"="fdata.buttons")
</template>

<script>
import Moment from 'moment'
import _ from 'lodash'

const htmlToTypeImage = x => {
  switch (x.type) {
    case 'type_rawHtml':
      let img = /<img.*?src=['"](.*?)['"]/.exec(x.value)
      return img ? {type: 'type_image', src: img[1]} : x
    default:
      return x
  }
}

const Event = x => {
  let image, buttons
  let [title, date, desc, ...rest] = x
  if (rest.length > 1) {
    image = htmlToTypeImage(_.head(rest))
    buttons = _.last(rest)
  } else {
    image = {}
    buttons = _.head(rest)
  }
  buttons.content = _.map(buttons.content, xs => {
    return _.has(xs, 'openAs') ? _.set(xs, 'openAs', 'modal') : xs
  })
  return {type: 'event', title, date, desc, image, buttons}
}

export default {
  data () {
    return {
      uid: this.$parent.uid
    }
  },
  props: {
    fdata: {
      type: Object,
      coerce (x) {
        return Event(x)
      },
      required: true
    }
  },
  filters: {
    format (val) {
      return Moment(val).format('D MMM YYYY')
    },
    backdrop (x) {
      return {
        'background-image': `url(${x.src})`,
        'width': '100%',
        'height': '100%',
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center center'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// event.vue?0783bcce